import React from "react";

const DeleteIcon = ({
  style = {},
  width = "70",
  height = "70",
  className = "",
  fill = "#7758B3",
  stroke = "#7758B3",
  viewBox = "0 0 70 70",
}) => (
<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.3335 3.00004H13.6668V4.33337H12.3335V13C12.3335 13.1769 12.2633 13.3464 12.1382 13.4714C12.0132 13.5965 11.8436 13.6667 11.6668 13.6667H2.3335C2.15669 13.6667 1.98712 13.5965 1.86209 13.4714C1.73707 13.3464 1.66683 13.1769 1.66683 13V4.33337H0.333496V3.00004H3.66683V1.00004C3.66683 0.82323 3.73707 0.65366 3.86209 0.528636C3.98712 0.403612 4.15669 0.333374 4.3335 0.333374H9.66683C9.84364 0.333374 10.0132 0.403612 10.1382 0.528636C10.2633 0.65366 10.3335 0.82323 10.3335 1.00004V3.00004ZM11.0002 4.33337H3.00016V12.3334H11.0002V4.33337ZM5.00016 6.33337H6.3335V10.3334H5.00016V6.33337ZM7.66683 6.33337H9.00016V10.3334H7.66683V6.33337ZM5.00016 1.66671V3.00004H9.00016V1.66671H5.00016Z" fill="#5D737E"/>
</svg>
   
);

export default DeleteIcon;
